import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db296cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "q-px-sm q-pt-xs"
}
const _hoisted_3 = { class: "row items-center no-wrap" }
const _hoisted_4 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonFilterSidebarHeader = _resolveComponent("PersonFilterSidebarHeader")!
  const _component_SelectedPersonAvatars = _resolveComponent("SelectedPersonAvatars")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_PersonPicker = _resolveComponent("PersonPicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PersonFilterSidebarHeader, {
        ref: "header",
        searching: _ctx.searching,
        keyword: _ctx.keyword,
        onSearch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.keyword = $event)),
        onOpenSearch: _ctx.openSearch,
        onCloseSearch: _ctx.closeSearch,
        onClose: _ctx.close
      }, null, 8, ["searching", "keyword", "onOpenSearch", "onCloseSearch", "onClose"]),
      (_ctx.selectedPersons.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_SelectedPersonAvatars, {
                  persons: _ctx.selectedPersons,
                  onDeselect: _ctx.deselect
                }, null, 8, ["persons", "onDeselect"])
              ]),
              _createVNode(_component_q_btn, {
                size: "sm",
                color: "grey",
                label: "Clear",
                icon: "fa fa-times",
                flat: "",
                dense: "",
                "no-caps": "",
                onClick: _ctx.clearSelection
              }, null, 8, ["onClick"])
            ]),
            _createVNode(_component_q_separator)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "person-sidebar__scroll-wrapper",
        style: _normalizeStyle(`max-height: ${_ctx.scrollHeight};`)
      }, [
        _createVNode(_component_PersonPicker, {
          ref: "picker",
          "client-id": _ctx.clientId,
          mode: "multi",
          "model-value": _ctx.selectedIds,
          keyword: _ctx.keyword,
          "empty-label": _ctx.keyword ? 'No matches' : 'No people detected',
          "onUpdate:modelValue": _ctx.onSelect,
          onLoaded: _ctx.updateKnownPersons
        }, null, 8, ["client-id", "model-value", "keyword", "empty-label", "onUpdate:modelValue", "onLoaded"])
      ], 4)
    ])
  ]))
}